import React from 'react';
import { FormattedMessage } from 'react-intl';
import { UPDATE_BACK, UPDATE_CUP, CUP_COMPENSATION } from '../data/constants';
import { updateBack, updatedBackSize, updateCup } from '../utils/helpers';

export const getStageButtonData = ({
  country,
  cupChange,
  goToStageEight,
  setBackChange,
  setBackSize,
  setCupChange,
  setCupSize,
  setPartTwoSelected,
  tempBackCache,
  tempCupCache,
  togglePartTwo,
}) => ({
  stage5Data: [
    {
      text: (
        <FormattedMessage
          id="size-quiz.size-two"
          defaultMessage="1 inch/2.5cm"
        />
      ),
      func: () => {
        setBackSize(tempBackCache);
        setCupSize(tempCupCache.cupSize);
        setBackChange(0);
        setCupChange(0);
      },
    },
    {
      text: (
        <FormattedMessage
          id="size-quiz.size-three"
          defaultMessage="2 inch/5cm"
        />
      ),
      func: () => {
        // If 1 size down exists then update
        const newBackSize = updatedBackSize({
          sizeChange: -1,
          country,
          backSize: tempBackCache,
          cupSize: tempCupCache.cupSize,
        });
        if (newBackSize) {
          updateBack({
            updateType: UPDATE_BACK,
            numberOfSizes: -1,
            newBackSize,
            setBackSize,
            setBackChange,
          });
          // Reset cup to zero (For case when user has selected '3 inches' and changes their mind)
          updateCup({
            updateType: CUP_COMPENSATION,
            cup: tempCupCache,
            numberOfSizes: 0,
            country,
            setCupSize,
          });
          return;
        }
        // Go down 1 on cup if no lower back size exists
        updateCup({
          updateType: CUP_COMPENSATION,
          cup: tempCupCache,
          numberOfSizes: -1,
          country,
          setCupSize,
        });
      },
    },
    {
      text: (
        <FormattedMessage
          id="size-quiz.size-four"
          defaultMessage="3 inches/7.5cm or more"
        />
      ),
      func: () => {
        // If 2 sizes down exists then update
        let newBackSize = updatedBackSize({
          sizeChange: -2,
          country,
          backSize: tempBackCache,
          cupSize: tempCupCache.cupSize,
        });
        if (newBackSize) {
          updateBack({
            updateType: UPDATE_BACK,
            numberOfSizes: -2,
            newBackSize,
            setBackSize,
            setBackChange,
          });
          return;
        }
        // If 1 size down exits then go down 1 on back and 1 on cup
        newBackSize = updatedBackSize({
          sizeChange: -1,
          country,
          backSize: tempBackCache,
          cupSize: tempCupCache.cupSize,
        });
        if (newBackSize) {
          updateBack({
            updateType: UPDATE_BACK,
            numberOfSizes: -1,
            newBackSize,
            setBackSize,
            setBackChange,
          });
          updateCup({
            updateType: CUP_COMPENSATION,
            cup: tempCupCache,
            numberOfSizes: -1,
            country,
            setCupSize,
          });
        } else {
          // Go down 2 on cup if no lower back sizes exist
          updateCup({
            updateType: CUP_COMPENSATION,
            cup: tempCupCache,
            numberOfSizes: -2,
            country,
            setCupSize,
          });
        }
      },
    },
  ],
  stage7aData: [
    {
      text: <FormattedMessage id="size-quiz.yes" defaultMessage="Yes" />,
      func: () => {
        togglePartTwo(false);
        setPartTwoSelected(0);
      },
    },
    {
      text: <FormattedMessage id="size-quiz.no" defaultMessage="No" />,
      func: () => {
        togglePartTwo(true);
      },
    },
  ],
  stage7bData: [
    {
      text: (
        <FormattedMessage
          id="size-quiz.size-two"
          defaultMessage="1 inch/2.5cm"
        />
      ),
      func: () =>
        updateCup({
          updateType: UPDATE_CUP,
          cup: tempCupCache,
          numberOfSizes: 1,
          country,
          setCupChange,
          setCupSize,
        }),
    }, // Cup +1
    {
      text: (
        <FormattedMessage
          id="size-quiz.size-three"
          defaultMessage="2 inch/5cm"
        />
      ), // Cup +2
      func: () =>
        updateCup({
          updateType: UPDATE_CUP,
          cup: tempCupCache,
          numberOfSizes: 2,
          country,
          setCupChange,
          setCupSize,
        }),
    },
    {
      text: (
        <FormattedMessage
          id="size-quiz.size-four"
          defaultMessage="3 inches/7.5cm or more"
        />
      ), // Cup +3
      func: () =>
        updateCup({
          updateType: UPDATE_CUP,
          cup: tempCupCache,
          numberOfSizes: 3,
          country,
          setCupChange,
          setCupSize,
        }),
    },
  ],
  stage8Data: [
    {
      text: <FormattedMessage id="size-quiz.boobs" defaultMessage="Boobs" />,
      func: () => {
        if (goToStageEight) return;
        updateCup({
          updateType: UPDATE_CUP,
          cup: tempCupCache,
          numberOfSizes: 1,
          country,
          setCupChange,
          setCupSize,
        });
      },
    },
    {
      text: <FormattedMessage id="size-quiz.ribs" defaultMessage="Ribs" />,
      func: () => {
        if (goToStageEight) return;
        updateCup({
          updateType: UPDATE_CUP,
          cup: tempCupCache,
          numberOfSizes: 0,
          country,
          setCupChange,
          setCupSize,
        });
      },
    },
  ],
  stage9aData: [
    {
      text: <FormattedMessage id="size-quiz.yes" defaultMessage="Yes" />,
      func: () => {
        togglePartTwo(true);
      },
    },
    {
      text: <FormattedMessage id="size-quiz.no" defaultMessage="No" />,
      func: () => {
        togglePartTwo(false);
        setPartTwoSelected(0);
        updateCup({
          updateType: UPDATE_CUP,
          cup: tempCupCache,
          numberOfSizes: 0,
          country,
          setCupChange,
          setCupSize,
        });
      },
    },
  ],
  stage9bData: [
    {
      text: (
        <FormattedMessage
          id="size-quiz.small-overflow"
          defaultMessage="Small overflow"
        />
      ),
      func: () => {
        if (goToStageEight) {
          updateCup({
            updateType: UPDATE_CUP,
            cup: tempCupCache,
            numberOfSizes: 0,
            country,
            setCupChange,
            setCupSize,
          });
          return;
        }
        updateCup({
          updateType: UPDATE_CUP,
          cup: tempCupCache,
          numberOfSizes: 1,
          country,
          setCupChange,
          setCupSize,
        });
      },
    },
    {
      text: (
        <FormattedMessage
          id="size-quiz.noticeable-overflow"
          defaultMessage="Noticeable overflow"
        />
      ),
      func: () => {
        if (goToStageEight) {
          // If they answered question 8 and went up less than 1 cup then
          // apply changes, but only add 1 more cup size
          if (cupChange < 2)
            updateCup({
              updateType: UPDATE_CUP,
              cup: tempCupCache,
              numberOfSizes: 1,
              country,
              setCupChange,
              setCupSize,
            });
          return;
        }
        updateCup({
          updateType: UPDATE_CUP,
          cup: tempCupCache,
          numberOfSizes: 2,
          country,
          setCupChange,
          setCupSize,
        });
      },
    },
  ],
  stage10aData: [
    {
      text: <FormattedMessage id="size-quiz.yes" defaultMessage="Yes" />,
      func: () => {
        togglePartTwo(true);
      },
    },
    {
      text: <FormattedMessage id="size-quiz.no" defaultMessage="No" />,
      func: () => {
        togglePartTwo(false);
        setPartTwoSelected(0);
        updateCup({
          updateType: UPDATE_CUP,
          cup: tempCupCache,
          numberOfSizes: 0,
          country,
          setCupChange,
          setCupSize,
        });
      },
    },
  ],
  stage10bData: [
    {
      text: (
        <FormattedMessage
          id="size-quiz.size-one"
          defaultMessage="Half inch/1cm"
        />
      ),
      func: () => {
        updateCup({
          updateType: UPDATE_CUP,
          cup: tempCupCache,
          numberOfSizes: -1,
          country,
          setCupChange,
          setCupSize,
        });
      },
    },
    {
      text: (
        <FormattedMessage
          id="size-quiz.size-two"
          defaultMessage="1 inch/2.5cm"
        />
      ),
      func: () => {
        updateCup({
          updateType: UPDATE_CUP,
          cup: tempCupCache,
          numberOfSizes: -2,
          country,
          setCupChange,
          setCupSize,
        });
      },
    },
  ],
});
